module.exports = __webpack_public_path__ + "img/custom_form.c674059a.jpg";